module.exports = __webpack_public_path__ + "static/SouldollA-5fc57c635250c7ac8eeaccfd136e94d6.gif";